import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
/**
 * `internal.pending_actions` wire schemas (admin-arch §3.11.1, PRD §12.2).
 *
 * Two-admin destructive-action workflow. MVP supports only
 * `action_type='custom_field.delete'`; the enum will widen without migration
 * as new destructive actions adopt the pattern (e.g. `account.delete`).
 */
export const pendingActionTypeEnum = z.enum(['custom_field.delete']);
export const pendingActionStatusEnum = z.enum([
    'pending',
    'approved',
    'rejected',
    'expired',
    'revoked',
]);
export const pendingActionTargetEntityTypeEnum = z.enum([
    'custom_field_definition',
]);
export const pendingActionSchema = z.object({
    id: uuidSchema,
    action_type: pendingActionTypeEnum,
    target_entity_type: pendingActionTargetEntityTypeEnum,
    target_entity_id: uuidSchema,
    initiator_user_id: uuidSchema,
    initiator_reason: z.string().nullable(),
    payload: z.unknown().nullable(),
    status: pendingActionStatusEnum,
    approver_user_id: uuidSchema.nullable(),
    decided_at: isoDateTimeSchema.nullable(),
    decided_reason: z.string().nullable(),
    expires_at: isoDateTimeSchema,
    executed_at: isoDateTimeSchema.nullable(),
    created_at: isoDateTimeSchema,
});
export const pendingActionListResponseSchema = z.object({
    items: z.array(pendingActionSchema),
});
/**
 * Optional approver/rejecter rationale recorded in `decided_reason`. Same
 * shape for both verbs so the front-end shares one confirmation modal.
 */
export const pendingActionDecisionSchema = z.object({
    reason: z.string().min(1).max(2000).optional(),
});
/**
 * Query filter for `GET /admin/pending-actions` — defaults to active
 * (`status='pending'`) so the Notification Center badge stays focused on
 * actionable items.
 */
export const pendingActionListFilterSchema = z.object({
    status: pendingActionStatusEnum.optional(),
    action_type: pendingActionTypeEnum.optional(),
});
//# sourceMappingURL=pending-action.js.map